module.exports = __webpack_public_path__ + "static/media/Saudi Arabia - SA.d7358ea5.png";